import { Check } from "lucide-react";
import { TRANSFORMATIONS, TESTIMONIALS } from "@/lib/brand";
import { WinsWall } from "@/components/WinsWall";

export default function ClientWins() {
  return (
    <div className="space-y-10 lg:mt-0 mt-10" data-testid="client-wall-of-wins">
      <header>
        <div className="overline">Wall of wins</div>
        <h1 className="font-serif text-4xl sm:text-5xl mt-3">
          Women who<br />
          <span className="font-script normal-case" style={{ fontSize: "1.05em", color: "var(--accent)", letterSpacing: 0 }}>did the work.</span>
        </h1>
        <p className="text-secondary-luxe text-sm mt-4 max-w-2xl">
          Every win counts — post yours, cheer the others on. Keep going. Your win belongs on this wall.
        </p>
      </header>

      <WinsWall />

      <header className="pt-4">
        <div className="overline">Transformations</div>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5">
        {TRANSFORMATIONS.map((t, i) => (
          <article key={t.name} className="card-luxe overflow-hidden" data-testid={`wins-card-${t.name.toLowerCase()}`}>
            <img src={t.src} alt={`${t.name} transformation`} loading="lazy"
              className="w-full aspect-square object-cover -mx-6 -mt-6 mb-5" style={{ width: "calc(100% + 3rem)" }} />
            <div className="overline">Win 0{i + 1}</div>
            <h3 className="font-serif text-2xl mt-2">{t.name}</h3>
            <p className="text-sm italic mt-2 text-secondary-luxe">{t.condition}</p>
            <ul className="mt-4 space-y-2">
              {t.results.map((r) => (
                <li key={r} className="text-sm flex items-start gap-2 text-secondary-luxe">
                  <Check size={13} className="mt-0.5 flex-shrink-0" style={{ color: "var(--accent)" }} />
                  <span>{r}</span>
                </li>
              ))}
            </ul>
          </article>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {TESTIMONIALS.map((t) => (
          <article key={t.name} className="card-luxe" data-testid={`wins-quote-${t.name.toLowerCase().replace(/\s/g, "-")}`}>
            <div className="overline">{t.role}</div>
            <h3 className="font-serif text-2xl mt-2">{t.name}</h3>
            <div className="bronze-rule mt-4" />
            <p className="font-soft text-base mt-5 leading-relaxed text-secondary-luxe">{t.body}</p>
          </article>
        ))}
      </div>
    </div>
  );
}
